import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { type NodeApi } from "react-arborist";

interface DeleteFilesModalProps {
  files: NodeApi;
  setFiles: (files: NodeApi | null) => void;
  onConfirmDelete: (files: NodeApi) => any;
  onCancelDelete: () => void;
}

const DeleteFilesModal: FC<DeleteFilesModalProps> = ({
  files,
  setFiles,
  onConfirmDelete,
  onCancelDelete,
}) => {
  return (
    <Modal
      open={!!files}
      setOpen={() => {
        setFiles(null);
      }}
      title="Delete Pipeline Files"
      confirmText="Delete"
      confirmButtonColor={ButtonColor.Red}
      onCancel={() => onCancelDelete}
      onConfirm={() => onConfirmDelete(files)}>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Are you sure you want to delete{" "}
          <span className="font-semibold">{files?.data?.name}</span>?
          {files.isInternal && (
            <p>All associated files in this folder will be deleted as well</p>
          )}
        </p>
      </div>
    </Modal>
  );
};

export default DeleteFilesModal;
